import { createContext } from "react"
import { SelectDataType } from "src/components/atom/SelectDataType"

export interface LoginContextValue {
  loggedin: boolean
  accessToken: string
  awsID: string
  userID?: number
  userType?: number
  jobs: SelectDataType[]
  areas: SelectDataType[]
  startupStages: SelectDataType[]
  startupPlans: SelectDataType[]
  routes: SelectDataType[]
  companyTypes: SelectDataType[]
  eventCategories: SelectDataType[]
  initialized: boolean
  handleLogin: any
  logout: any
  refreshMasterData: any
  checkLoginStatus: any
  getAreaDetail: any
  getJobTitle: any
  getJobTitles: any
  getLineAccessToken: any
}

export const LoginContext = createContext<null | LoginContextValue>(null)
